import Button from '@atoms/Button/Button';
import Image from '@atoms/Image/Image';
import Text from '@atoms/Text/Text';
import Video from '@atoms/Video/Video';
import { IInspirationCard } from '@models/IInspirationCard';
import ThemeEnum from '@models/enums/ThemeEnum';
import { handleHexCode } from '@utility/helpers/handleHexCode';
import classNames from 'classnames';

const InspirationCard = ({
  cta,
  image,
  text,
  theme,
  video,
  backgroundColour,
  mobileNarrow,
}: IInspirationCard) => {
  const hasMedia = image || video?.videoSource;
  const videoAttributes = {
    playsinline: true,
    muted: true,
    playing: true,
    loop: true,
  };

  return (
    <article
      className={classNames(
        'tw-relative tw-h-full',
        mobileNarrow ? 'tw-px-2 tw-py-4 md:tw-p-sm' : 'tw-p-sm'
      )}
      style={
        !hasMedia
          ? {
              backgroundColor: backgroundColour
                ? handleHexCode(backgroundColour)
                : '#ffffff',
            }
          : {}
      }
    >
      <Image
        image={image}
        imageClasses="tw-absolute tw-w-full tw-h-full tw-object-center tw-object-cover tw-inset-0"
      />

      {video?.videoSource && (
        <Video
          videoSource={video.videoSource}
          videoAttributes={videoAttributes}
          controls={false}
          classes="tw-absolute tw-w-full tw-h-full [&_video]:tw-object-center [&_video]:tw-object-cover tw-inset-0"
        />
      )}

      <div className="tw-relative tw-z-10 tw-flex tw-h-full tw-flex-col tw-justify-between">
        <Text
          variant="heading-28"
          className={classNames(
            theme === ThemeEnum.Light ? 'tw-text-white' : 'tw-text-black'
          )}
        >
          {text}
        </Text>
        <Button
          as="link"
          key={text}
          modifier="fill"
          variant={theme === ThemeEnum.Light ? 'white' : 'grey30'}
          href={cta.url}
          target={cta.target}
          label={cta.text}
        />
      </div>
    </article>
  );
};
export default InspirationCard;
